<template>
    <v-dialog-old ref="dialog" id="citiesDialog">
        <template v-slot:footer>
            <div class="buttons">
                <div class="right">
                    <template v-for="city in cityOptions">
                        <button style="margin: 6px;" class="greenHover" @click="showSitemap(city.value)">{{city.text}}</button>
                    </template>
                    <br/>
                    <button class="redHover" @click="hide">Отмена</button>
                </div>
            </div>
        </template>
    </v-dialog-old>
</template>

<script>

import Vue from 'vue';
import { mapState } from "vuex";

export default {
    data() {
        return {
            city: {
                url: ''
            },
        }
    },
    props: {},
    created() {
        this.$store.dispatch('dictionary/fetchCityOptions');
    },
    computed: {
        ...mapState({
            cityOptions: state => state.dictionary.cityOptions,
        }),
    },
    methods: {
        show: function (url) {
            console.log(url)
            this.url = url;
            this.$refs.dialog.show();
        },
        showSitemap(city){
            window.open(this.url.replace('[city]',city) + '?nocache=' + (new Date()).getTime(), "_blank", "width=600, height=800");
        },
        hide: function () {
            this.$refs.dialog.hide();
        }
    }
}
</script>
<style scoped lang="scss">
    #citiesDialog {
        width: 850px;
    }
</style>
